var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLighting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.002 512.002",
    height: 512,
    viewBox: "0 0 512.002 512.002",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m128.911 510.218c6.625 3.555 14.839 1.649 19.234-4.413l240-331c3.31-4.564 3.78-10.599 1.218-15.622-2.562-5.022-7.724-8.184-13.361-8.184h-63.598l76.482-128.32c2.763-4.635 2.823-10.397.157-15.089-2.664-4.692-7.645-7.59-13.041-7.59h-180c-6.889 0-12.892 4.692-14.556 11.376l-60 241c-1.115 4.48-.105 9.224 2.737 12.861 2.843 3.638 7.202 5.763 11.818 5.763h68.387l-82.438 220.752c-2.626 7.03.348 14.919 6.961 18.466zm111.143-248.97c1.721-4.605 1.074-9.761-1.729-13.8s-7.407-6.448-12.323-6.448h-70.808l52.531-211h141.875l-76.482 128.32c-2.763 4.635-2.823 10.397-.157 15.089 2.665 4.692 7.646 7.59 13.042 7.59h60.596l-157.903 217.773z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/Lighting.1e9755f7.svg";
export { ForwardRef as ReactComponent };